import ArtworkFrame from '../../src/legacy/ArtworkFrame.tsx';
export default ArtworkFrame;
